export const HEADER_BPM_FACING = 'BPM Facing Note'
export const BUTTON_ADD_NEW = '+ New'
export const LABEL_NOTES = 'Notes'
export const LABEL_CREATE_NOTES_1 = 'No notes yet.'
export const LABEL_CREATE_NOTES_2 = 'Click to create one.'
export const LABEL_REASON_NOTE = 'Reason Note'
export const TITLE_DELTEK_NOTE = 'Deltek Internal Notes'
export const TITLE_BPM_NOTE = 'BPM Facing Note'
export const TITLE_DELETE_NOTE = 'Delete Note'
export const TITLE_GENERAL_NOTE = 'General Note'
export const VARIABLE_NOTES_COUNT_LABEL = (count: number) =>
    `${count} Note${count > 1 || count === 0 ? 's' : ''}`
export const VARIABLE_NOTES_COUNT = (count: number) => `(${count} total)`
export const VARIABLE_NOTES_TITLE = (action: string) =>
    `Internal Note - ${action}`
export const PROMPT_DELETE_NOTE = 'Are you sure you want to delete this note?'
export const PROMPT_OVERWRITE_NOTE =
    'Changing this setting again will overwrite the temporarily stored note. Are you sure you want to proceed? '
export const PROMPT_REMOVE_NOTE =
    'Going back to the original setting will remove the temporarily stored note. Are you sure you want to proceed? '

export const noteTypes = {
    COPYMOVE: 'Copy/Move',
    GENERALNOTE: 'General Notes',
    DELETEORSTATUSCHANGE: 'Delete or Status Change',
    LISTINGTYPECHANGE: 'Listing Type Change',
}

export const typeAction = {
    COPY: 'COPYMOVE',
    COPYMOVE: 'COPYMOVE',
    DELETEORSTATUSCHANGE: 'Delete or Status Change',
    MOVE: 'COPYMOVE',
    GENERALNOTE: 'GENERALNOTE',
    DELETE: 'DELETEORSTATUSCHANGE',
    STATUSCHANGE: 'DELETEORSTATUSCHANGE',
    LISTINGTYPECHANGE: 'LISTINGTYPECHANGE',
}

export const titleHeaderAction = {
    COPY: 'Copy',
    MOVE: 'Move',
    GENERALNOTE: 'General Note',
    DELETE: 'Delete',
    STATUSCHANGE: 'Status',
    LISTINGTYPECHANGE: 'Listing Type',
    DELETEORSTATUSCHANGE: 'Delete or Status Change',
    COPYMOVE: 'Copy / Move',
}

export const noteReasonLabels = {
    COPY: 'Copy Reason',
    MOVE: 'Move Reason',
    GENERALNOTE: 'General Notes',
    DELETE: 'Delete Reason',
    STATUSCHANGE: 'Status Change Reason',
    LISTINGTYPECHANGE: 'Listing Type Change Reason',
    DELETEORSTATUSCHANGE: 'Delete or Status Change Reason',
    COPYMOVE: 'Copy / Move Reason',
}

export const cancelAddNoteWarning = {
    DELETE: 'Canceling this change will disregard the deletion of the listing.',
    LISTINGTYPECHANGE:
        'Canceling this change will revert the "Listing Type" back to the previous setting.',
    STATUSCHANGE:
        'Canceling this change will revert the "Status" back to the previous setting.',
}
